export default __webpack_public_path__ + "22dc99c7c7c796e50c1f0e344fcf3fc7.png";